import { render, staticRenderFns } from "./MessageDetail.vue?vue&type=template&id=5dab861b&"
import script from "./MessageDetail.vue?vue&type=script&lang=js&"
export * from "./MessageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports